import { render, staticRenderFns } from "./ModalZposTransaction.vue?vue&type=template&id=488af2ec&"
import script from "./ModalZposTransaction.vue?vue&type=script&lang=js&"
export * from "./ModalZposTransaction.vue?vue&type=script&lang=js&"
import style0 from "./ModalZposTransaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports